export default __webpack_public_path__ + "static/iac_cover-c6d9ff7ba1443ced65458e39e9e0b44d.png";